/* eslint-disable import/prefer-default-export */
import { gql } from '@apollo/client';

export const DIRECT_UPLOAD_CANDIDATE_RESUME_MUTATION = gql`
  mutation tenantDirectUpload( $file: [TenantDirectUploadCreateInput!] ) {
    tenant {
      directUploadCandidate( create: $file, extractText: true ) {
        metadata {
          url
          headers
          blobId
          signedBlobId
           extractText {
            url
            headers
            body
          }
        }
        errors
      }
    }
}
`;
